import React from 'react';
import { FormattedMessage } from 'react-intl';

export const PickupTimeLabel = () => <FormattedMessage defaultMessage='Pickup' description='fulfillmentPlanner.PickupTime' id='xi1Ate' />;
